import React from "react";
import { Reveal, Overline } from "./Reveal";

const IMG = "https://images.unsplash.com/photo-1706074797611-a02f9ed06439?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export const About = () => (
  <section id="about" data-testid="about" className="border-t border-line bg-surface">
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-24 sm:py-36 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
      <Reveal className="lg:col-span-6 order-2 lg:order-1">
        <div className="relative">
          <img src={IMG} alt="Halloway trading floor" className="w-full aspect-[4/5] object-cover grayscale-[0.3] contrast-[1.05]" />
          <div className="absolute -bottom-px -right-px bg-brass text-ink p-6 sm:p-8 max-w-[220px]">
            <div className="font-mono text-4xl font-light">2026</div>
            <div className="font-mono text-[10px] uppercase tracking-[0.2em] mt-2">The year we opened the desk — built for the cycles ahead</div>
          </div>
        </div>
      </Reveal>

      <div className="lg:col-span-6 order-1 lg:order-2">
        <Reveal><Overline>The Firm</Overline></Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-6 leading-[1.05]">
            A trading house, in the traditional sense.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="text-mute leading-relaxed mt-8 text-lg">
            Goose the Gander is a proprietary trading firm. We trade our own money — no client mandates, no outside pressure, no compromise. That independence is the foundation of everything we do.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="text-mute leading-relaxed mt-5">
            Founded in 2026 on a simple, old-fashioned idea: find exceptional traders, back them properly with capital, technology and mentorship, and get out of their way. Discipline today, freedom tomorrow — it's not a slogan, it's how we run the desk.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="grid grid-cols-2 gap-8 mt-12 border-t border-line pt-10">
            {[["Independent", "100% firm capital"], ["Multi-strategy", "Discretionary & systematic"], ["Aligned", "Traders keep the majority"]].map(([t, s]) => (
              <div key={t}>
                <div className="font-serif text-xl text-bone">{t}</div>
                <div className="font-mono text-xs uppercase tracking-[0.15em] text-mute mt-1">{s}</div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
